



import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";
import { useState } from "react";

export default function ServicePopularity({ services }) {
  const [selectedService, setSelectedService] = useState(null);

  return (
    <div className="h-auto w-full space-y-4">
      <div className="h-64">
        <ResponsiveContainer>
          <BarChart data={services} margin={{ top: 10, right: 20, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5f3fa" />
            <XAxis
              dataKey="name"
              tick={{ fill: "#3383B2", fontWeight: 600 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis hide />
            <Tooltip cursor={false} />
            <Bar
              dataKey="value"
              fill="#3383B2"
              // fill="#0077B6"
              radius={[6, 6, 0, 0]}
              barSize={30}
              activeBar={false}
              isAnimationActive={false}
              onClick={(data) => setSelectedService(data)}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {selectedService && (
        <div className="bg-gray-100 p-4 rounded-lg shadow-inner">
          <div className="flex justify-between mb-2">
            <h3 className="font-semibold text-lg">Details: {selectedService.name}</h3>
            <button className="text-sm text-red-600" onClick={() => setSelectedService(null)}>
              Close
            </button>
          </div>
          <ul className="text-sm list-disc pl-5 space-y-1">
            {selectedService.details.map((item) => (
              <li key={item.id}>
                Customer: {item.customer}, Amount: {item.amount}, Date: {item.date}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

